var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetteredList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lettered-list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.389 13.9723L13.202 4.87204C13.0181 4.34699 12.5551 4 12.0385 4C11.5241 4 11.0627 4.34409 10.8773 4.86594L7.6417 13.9723M16.389 13.9723L18.5 20M16.389 13.9723H7.6417M5.5 20L7.6417 13.9723",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetteredList);
export default __webpack_public_path__ + "static/media/lettered-list.8ffae8b03c43de8d4bfaf78049e12502.svg";
export { ForwardRef as ReactComponent };